import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AI_DISCLAIMER_COPY } from '../../models/descriptions/ai-disclaimer';

export type AiDisclaimerVariant = 'output' | 'trigger';

@Component({
  selector: 'app-ai-disclaimer',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './ai-disclaimer.component.html',
  styleUrl: './ai-disclaimer.component.scss',
})
export class AiDisclaimerComponent {
  @Input() variant: AiDisclaimerVariant = 'output';

  get text(): string {
    return this.variant === 'trigger'
      ? AI_DISCLAIMER_COPY.trigger
      : AI_DISCLAIMER_COPY.output;
  }
}
